import "@/styles/escaperoom/menu.scss";

import { Button, Modal, Rating, Text, Textarea, Title } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BsFillPuzzleFill, BsPuzzle } from "react-icons/bs";

import { useStateContext } from "@/context/context-provider";

const EndScreen = () => {
    const { setInPointerLock, roomUrl, endScreenOpen, setEndScreenOpen } = useStateContext();
    const [rating, setRating] = useState(0);
    const [difficulty, setDifficulty] = useState(0);
    const [feedbackText, setFeedbackText] = useState("");
    const { t } = useTranslation();

    const submitRating = async () => {
        if (!roomUrl) {
            return;
        }

        const data = JSON.parse(localStorage.getItem(roomUrl) || "{}");
        const sessionId = data.sessionId;

        if (!sessionId) {
            console.error("Keine sessionId beim Abschicken des Ratings gefunden.");
            return;
        }

        const requestBody: {
            sessionId: string;
            rating?: number;
            difficulty?: number;
            text?: string;
        } = { sessionId };

        if (rating > 0) {
            requestBody.rating = rating;
        }

        if (difficulty > 0) {
            requestBody.difficulty = difficulty;
        }

        if (feedbackText && feedbackText.trim() !== "") {
            requestBody.text = feedbackText.trim();
        }

        try {
            await fetch("/api/ratings", {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });
        } catch (error) {
            console.error("Rating konnte nicht gespeichert werden:", error);
        }
    };

    useEffect(() => {
        if (endScreenOpen) {
            setInPointerLock(false);

            if (endScreenOpen && roomUrl) {
                const data = JSON.parse(localStorage.getItem(roomUrl) || "{}");

                if (!data.isFrozen) {
                    const endTimeStamp = Date.now();
                    data.isFrozen = true;
                    localStorage.setItem(roomUrl, JSON.stringify(data));

                    const sessionId = data.sessionId;
                    if (sessionId) {
                        fetch("/api/ratings", {
                            method: "PATCH",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                                sessionId,
                                finishedAt: new Date(endTimeStamp),
                            }),
                        }).catch((error) => console.error("Fehler beim Sichern der Endzeit:", error));
                    }
                }
            }
        } else {
            setTimeout(() => {
                setInPointerLock(true);
            }, 1);
        }

        const handleKeyDown = (e) => {
            if (e.key === "Escape" && endScreenOpen) {
                setTimeout(() => {
                    setInPointerLock(true);
                    setEndScreenOpen(false);
                }, 100);
            }
        };

        globalThis.addEventListener("keydown", handleKeyDown);
        return () => {
            globalThis.removeEventListener("keydown", handleKeyDown);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [endScreenOpen]);

    return (
        <Modal
            opened={endScreenOpen}
            centered
            lockScroll={false}
            onClose={() => setEndScreenOpen(false)}
            size="lg"
            radius="md"
            title={t("endscreen.title")}
            className="end-screen-modal">
            <Text className="description" c="var(--mantine-color-gray-6)">
                {t("endscreen.description1")}
            </Text>
            <Title order={4} mt="sm">
                {t("endscreen.ratingTitle")}
            </Title>
            <Text className="description" mb="xs" c="var(--mantine-color-gray-6)">
                {t("endscreen.description2")}
            </Text>
            <label>{t("endscreen.rating")}</label>

            <Rating value={rating} onChange={setRating} mb="xs" color="var(--color-primary-6)" />

            <label>{t("endscreen.difficulty")}</label>
            <Rating
                mb="calc(var(--mantine-spacing-xs) / 2)"
                className="difficulty-rating"
                value={difficulty}
                onChange={setDifficulty}
                emptySymbol={<BsPuzzle color="var(--mantine-color-gray-6)" size={18} />}
                fullSymbol={<BsFillPuzzleFill color="var(--color-primary-6)" size={18} />}
            />
            <label> {t("endscreen.other")}</label>
            <Textarea
                value={feedbackText}
                onChange={(e) => {
                    setFeedbackText(e.target.value);
                }}
                placeholder={t("endscreen.otherPlaceholder")}
                maxRows={6}
                mb="xl"
            />
            <div className="button-container">
                <Button
                    lts=".06rem"
                    className="link"
                    onClick={async () => {
                        await submitRating();
                        localStorage.removeItem(roomUrl);
                        globalThis.location.href = "/";
                    }}>
                    {t("menu.menuButton")}
                </Button>
            </div>
        </Modal>
    );
};

export default EndScreen;
